import { getTokenHeader } from "@/helpers/commonHelper";
import axios from "axios";
const env = require(`@/environments/${process.env.VUE_APP_ENV_PATH}`);

export default {
  async getNewsApiKeys({ commit, state }, query) {
    const headers = getTokenHeader();
    if (headers && state.selectedPrincipal?.id) {
      try {
        const response = await axios.get(`${env.news_api_client_url}apiKey/`, {
          params: {
            ...query,
            principal: state.selectedPrincipal.id
          },
          headers
        });
        commit("SET_NEWS_API_KEYS", response?.data);
      } catch (e) {
        await this.dispatch("createError", e);
      }
    }
  },
  async getFeatures({ commit }, params) {
    const headers = getTokenHeader();
    const response = await axios.get(`${env.news_api_client_url}feature`, {
      headers,
      params
    });
    commit("SET_NEWS_FEATURES", response.data);
  },
  async getNewsArticleTypes({ commit }, params) {
    const headers = getTokenHeader();
    const response = await axios.get(`${env.news_api_client_url}article_type`, {
      headers,
      params
    });
    commit("SET_NEWS_ARTICLE_TYPES", response.data);
  },
  async getFeatureGroups({ commit }, params) {
    const headers = getTokenHeader();
    const response = await axios.get(
      `${env.news_api_client_url}feature_group`,
      {
        headers,
        params
      }
    );
    commit("SET_NEWS_FEATURE_GROUPS", response.data);
  },
  async getIssues({ commit }, params) {
    const headers = getTokenHeader();
    const response = await axios.get(`${env.news_api_client_url}issue/find`, {
      headers,
      params
    });
    let issues = response.data;
    issues = issues.map(item => {
      const deadlineDate = new Date(item.deadline_date);
      const currentTime = new Date();
      item.closed = deadlineDate < currentTime || item.status === "closed";
      if (item.closed) {
        item.disabled = true;
      }
      return item;
    });
    commit("SET_ISSUES", issues);
  },
  async getNewsAppContentTypes({ commit }, params) {
    const headers = getTokenHeader();
    const response = await axios.get(
      `${env.news_api_client_url}app_content_type`,
      {
        headers,
        params
      }
    );
    commit("SET_NEWS_APP_CONTENT_TYPES", response.data);
  },
  async getRelatedNews({ commit, state }, idArray) {
    const params = {
      principal_id: state.selectedPrincipal.id
    };
    const newsArray = [];

    idArray.asyncForEach(async id => {
      if (!id) return;
      const headers = getTokenHeader();
      const result = await axios.get(`${env.news_api_client_url}news/${id}`, {
        params,
        headers
      });
      newsArray.push(result.data);
    });
    commit("SET_RELATED_NEWS", newsArray);
  },
  async getAutocompleteNews({ commit }, params) {
    let news = [];
    const headers = getTokenHeader();
    const result = await axios.get(`${env.news_api_client_url}news/`, {
      params,
      headers
    });
    news = result.data;
    commit("SET_AUTOCOMPLETE_NEWS", news);
  },

  async getNewsConfig({ commit, state }) {
    const headers = getTokenHeader();
    if (headers) {
      const response = await axios.get(`${env.news_api_client_url}config`, {
        params: {
          principal_id: state.selectedPrincipal.id
        },
        headers
      });
      const organizer = response?.data ?? {};
      commit("SET_NEWS_CONFIG", organizer);
    }
  },
  async getFeatureGroupsForNews({ commit, state }, getAll = false) {
    const headers = getTokenHeader();
    if (headers)
      try {
        const response = await axios.get(
          `${env.news_api_client_url}feature_group/`,
          {
            headers,
            params: {
              principal_id: state.selectedPrincipal.id,
              all: getAll ? 1 : 0
            }
          }
        );
        commit("SET_FEATURE_GROUPS_FOR_NEWS", response?.data);
      } catch (ex) {
        throw new Error(`API Error: ${ex}`);
      }
    else throw new Error(`API Error: Headers missing`);
  }
};
